import {
  FETCH_ADMIN_MESSAGES,
  FETCH_ADMIN_MESSAGES_SUCCESS,
  FETCH_ADMIN_MESSAGES_FAILED,
  SEND_ADMIN_MESSAGE,
  STOP_FETCH_ADMIN_MESSAGES,
  FETCH_ALL_SUPPORT_CHATS,
  FETCH_ALL_SUPPORT_CHATS_SUCCESS,
  FETCH_ALL_SUPPORT_CHATS_FAILED
} from "../store/types";

const INITIAL_STATE = {
  messages: [],
  loading: false,
  error: {
    flag: false,
    msg: null
  },
  supportChats: [],
  chatsLoading: false,
  chatsError: {
    flag: false,
    msg: null
  }
}

export const adminsupportreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_ADMIN_MESSAGES:
      return {
        ...state,
        loading: true,
        error: {
          flag: false,
          msg: null
        }
      };
    case FETCH_ADMIN_MESSAGES_SUCCESS:
      return {
        ...state,
        messages: action.payload,
        loading: false
      };
    case FETCH_ADMIN_MESSAGES_FAILED:
      return {
        ...state,
        messages: [],
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case SEND_ADMIN_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload]
      };
    case STOP_FETCH_ADMIN_MESSAGES:
      return {
        ...state,
        messages: [],
        loading: false,
        error: {
          flag: false,
          msg: null
        }
      };
    case FETCH_ALL_SUPPORT_CHATS:
      return {
        ...state,
        chatsLoading: true,
        chatsError: {
          flag: false,
          msg: null
        }
      };
    case FETCH_ALL_SUPPORT_CHATS_SUCCESS:
      return {
        ...state,
        supportChats: action.payload,
        chatsLoading: false
      };
    case FETCH_ALL_SUPPORT_CHATS_FAILED:
      return {
        ...state,
        supportChats: [],
        chatsLoading: false,
        chatsError: {
          flag: true,
          msg: action.payload
        }
      };
    default:
      return state;
  }
} 